module.exports = __webpack_public_path__ + "static/media/backslash-logo.32565c4c.png";